module.exports = __webpack_public_path__ + "img/logo-light.1393f806.png";